/*
 * Public API Surface of ngx-syncscroll
 */

export * from './lib/ngx-syncscroll.module';
